import { IAppState } from '../../redux';

export function selectCurrentBet(state: IAppState): number {
  const {
    auction: { currentBet },
  } = state;

  return currentBet;
}
